import gql from "graphql-tag";
import { Query } from "react-apollo";
import { compose, graphql, ApolloProvider } from "react-apollo"; //apollo-client

import fetch from "node-fetch";
import reactStringReplace from "react-string-replace";
import CONTEXT from "./graphqlapi";
import client from "../../common/Apolloconfig/index";
//////////////////////////////////////////////QUEY SECTION START////////////////////////////////////////////////////

//Add Savedneighbor
const GQLAddSavedneighbor = gql`
  mutation addSavedneighbor(
    $neighborhoodId: String
    $userId: String
    $name: String
    $city: String
    $state: String
    $savedDate: String
    $updatedDate: String
    $savedStatus: Int
  ) {
    createsavedneighborhoodbyuser(
      neighborhoodId: $neighborhoodId
      userId: $userId
      name: $name
      city: $city
      state: $state
      savedDate: $savedDate
      updatedDate: $updatedDate
      savedStatus: $savedStatus
    ) {
      success
      message
    }
  }
`;

//Update Savedneighbor
const GQLUpdateSavedneighbor = gql`
  mutation updateSavedneighbor($id: String!, $name: String) {
    Updatesavedneighborhoodbyuser(id: $id, name: $name) {
      success
      message
    }
  }
`;

//Delete Savedneighbor
const GQLDeleteSavedneighbor = gql`
  mutation deleteSavedneighbor($id: String) {
    deletesavedneighborhoodbyuser(id: $id) {
      success
      message
    }
  }
`;

//Get All User
const QUERY_getAllSavedneighborList = gql`
  query getsavedneighborhoodbyuser(
    $start: Int
    $limit: Int
    $orderBy: String
    $order: String
    $fields: String
  ) {
    getsavedneighborhoodbyuser(
      start: $start
      limit: $limit
      orderBy: $orderBy
      order: $order
      fields: $fields
    ) {
      id
      neighborhoodId
      name
      city
      state
      savedDate
      npi
      value
      school
      crime
      walkability
      publicspaces
      curb
      others
      primaryschoolscore
      middleschoolscore
      highschoolscore
      medianprice
      latitude
      longitude
      geometry_cords
      is_display_prod
      is_display_dev
      nhfullname
      neighborhoodImages {
        imageurl
        thumbnailurl
      }
    }
  }
`;

const QUERY_checkSavedNeighborhoodbyuserStatus = gql`
  query checkSavedNeighborhoodbyuserStatus(
    $userId: String
    $neighborhoodId: String
  ) {
    checksavedneighborhoodbyuserStatus(
      userId: $userId
      neighborhoodId: $neighborhoodId
    ) {
      id
      neighborhoodId
      userId
      name
      city
      state
      savedDate
      updatedDate
      savedStatus
    }
  }
`;
//////////////////////////////////////////////QUEY SECTION WRAP////////////////////////////////////////////////////

//////////////////////////////////////////////FUNCTION SECTION START////////////////////////////////////////////////////

//Add Neighbor Function

async function addsavedneighborhoodbyuser(adddata) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: GQLAddSavedneighbor,
        variables: {
          neighborhoodId: adddata.neighborhoodId,
          userId: adddata.userId,
          name: adddata.name,
          city: adddata.city,
          state: adddata.state,
          savedDate: adddata.savedDate,
          updatedDate: adddata.updatedDate,
          savedStatus: adddata.savedStatus,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

//Update Function

async function updatesavedneighborhoodbyuser(updatedata) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: GQLUpdateSavedneighbor,

        variables: {
          id: updatedata.id,
          name: updatedata.name,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

//Delete Function

async function deletesavedneighborhoodbyuser(deletedataId) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: GQLDeleteSavedneighbor,
        variables: {
          id: deletedataId.id,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
//Get list by own query
async function getAllsavedneighborhoodbyuserList(getdata) {
  return new Promise((resolve, reject) => {
    client
      .query({
        query: QUERY_getAllSavedneighborList,
        options: {
          fetch: fetch,
        },
        variables: {
          start: getdata.start,
          limit: getdata.limit,
          orderBy: getdata.orderBy,
          order: getdata.order,
          fields: JSON.stringify(getdata.fields),
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function checkSavedNeighborhoodbyuserStatus(getdata) {
  return new Promise((resolve, reject) => {
    client
      .query({
        query: QUERY_checkSavedNeighborhoodbyuserStatus,
        options: {
          fetch: fetch,
        },
        variables: {
          userId: getdata.userId,
          neighborhoodId: getdata.neighborhoodId,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
//////////////////////////////////////////////FUNCTION SECTION WRAP////////////////////////////////////////////////////

export {
  addsavedneighborhoodbyuser,
  updatesavedneighborhoodbyuser,
  deletesavedneighborhoodbyuser,
  getAllsavedneighborhoodbyuserList,
  checkSavedNeighborhoodbyuserStatus,
};
